
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType, FeatureType,
} from '@appblocks/codegeneration/types';
import * as zephyr from './zephyr';
import * as simulator from './simulator';
import BaseGPIOPeripheral from '../_BaseGPIOPeripheral';

export default class Button extends BaseGPIOPeripheral {
    constructor() {
        super();
        this.id = 'button';
        this.name = 'Button';
        this.singleInstance = false;
        this.requirements = ['zephyr', 'gpio'];
        this.capabilities = ['button'];
        this.featureType = FeatureType.PERIPHERAL;
    }

    getState(settingId: string): SettingState {
        switch (settingId) {
            case 'state':
                return this.getSettingValue('direction') === '1' ? SettingState.DISABLED : SettingState.ENABLED;
            default:
                return SettingState.ENABLED;
        }
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return zephyr.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/gpio_type';
    }
}
